import {createAction} from "@reduxjs/toolkit";

const setUser = createAction('user/logged',(logged)=>{
  return {payload:{logged}}
})

export const UserActions ={
  setUser
}
